/* Opciones de Edición */

//*react- recursos
  import React, { useState, useEffect } from "react";
  import swal2 from "sweetalert2"; //npm install --save sweetalert2

//*componentes-utiles
  import CargandoSpin from "../../../../componentes/CargandoSpin";

//*clases 
  import ReactTooltip from "react-tooltip";
  import '../../../../css/mdi.css'; 

//*datos
  import etiquetasSSC from "../../../../datos/json/etiquetasSSC.json";
  
//*api's (servicios y store)
  import usersServicio from "../../../../api/recursos/users/users.servicio"; 
  import usersStore from "../../../../api/recursos/users/users.store"; 

//*store's

//*interfaces
  interface propsEditarLDAP {
    tokenStore:any,
    id:any,
    usuTipo:any,
    listaUsuarios:any,
    cambiaListaUsuarios:any,
    activaSwBotonGuardar:any,
    recargaConfiguracionPanel:any,
    recargaConfiguracionPanelEditar:any,
    recargaPaginaSSC:any,
  }

//*componente
  export default function EditarLDAP(props: propsEditarLDAP){
    var _ = require('underscore');
  
    //*api store
        const { guardaSearchUserLDAPStore, usuariosLDAPStore,
                generaObjErrorUsersStore} =  
            usersStore((state:any) =>( { 
                guardaSearchUserLDAPStore: state.guardaSearchUserLDAPStore,
                usuariosLDAPStore: state.usuariosLDAPStore,
                generaObjErrorUsersStore: state.generaObjErrorUsersStore,
        }));

    //*store's
    //*datos
    
    //*constantes y variables
      let etiRP = etiquetasSSC.RP;
      let etiGlobal = etiquetasSSC.Global;
      let x0:any, x1:any, x2:any, x3:any, x4:any, x5:any, x6:any, x7:any , x8:any  = '';
  
    //*useState
      const [swRecarga, setSwRecarga] = useState(false); //usado para remasterizar
      const [swRecargaConfiguracionPanelEditarLDAP, setSwRecargaConfiguracionPanelEditarLDAP] = useState(false); //usado para remasterizar esta página
      const [cargandoSpin, setCargandoSpin] = useState(false);
      
      const [swBotonBuscarFront, setSwBotonBuscarFront] = useState(false);
      const [swBotonAgregarFront, setSwBotonAgregarFront] = useState(false);
      const [swActivaListaLDAP, setSwActivaListaLDAP] = useState(false);

      const [usuariosLDAPFront, setUsuariosLDAPFront] = useState([]);

      const [valorInput, setValorInput] = useState("");
      const [listaUsuariosFront, setListaUsuariosFront] = useState(props.listaUsuarios);
      
      const [usuariosSeleccionado, setUsuariosSeleccionado] = useState({ name: "", email: ""});
    
    //*useEffect
      useEffect(()=> { // cargo
        //console.log('LDAP - monto');
        //console.log('unId', props.id);
        //console.log('usuTipo',props.usuTipo);
        //console.log('upUsuarios', props.listaUsuarios );
        setListaUsuariosFront(props.listaUsuarios);
        setValorInput('');
        setSwActivaListaLDAP(false);
        setSwRecarga(!swRecarga);
      },[]);
      
      useEffect(()=> { // uso este puente para recargar elementos del front
        console.log('LDAP - rederizando............');
        setSwRecargaConfiguracionPanelEditarLDAP(!swRecargaConfiguracionPanelEditarLDAP);
      },[swRecarga]);

    //*funciones
      const recargaPaginaSSC = () => { props.recargaPaginaSSC() } 

      const recargaConfiguracionPanel = () => {   props.recargaConfiguracionPanel() }

      const recargaConfiguracionPanelEditar = () => {   props.recargaConfiguracionPanelEditar() }

      const recargaConfiguracionPanelEditarLDAP = () => {
        //alert('recargaConfiguracionPanelEditarLDAP');
        //console.log('recargaConfiguracionPanelEditarLDAP....')
        setSwRecarga(!swRecarga); // con esto ejecuto un useEffect, lo uso para renderizar el front 
      }
     
      const actualizaInputLDAP =  (event:any) => {  
        //console.log('actualizaInputLDAP.value...',event.target.value);
        setValorInput(event.target.value); 
        setSwBotonBuscarFront(true);
        //console.log('valorInput............', valorInput);
        setSwRecarga(!swRecarga)
      }

      const limpiarInputLDAP = () => {  
        //alert('limpiarInputLDAP');
        var espejo:any = document.getElementById("inputLDAP") as HTMLInputElement | null; 
        if (espejo)  espejo.value= ""; 
        setValorInput(""); 
        setSwBotonBuscarFront(false);
        setSwBotonAgregarFront(false)
        setSwActivaListaLDAP(false);
      }

      const botonBuscar = () => {
        //alert('botonBuscar: ' + valorInput)
        let bodyAPIBuscar = { "name": "", "area_user": false, "limit": 50 }
        bodyAPIBuscar.name = valorInput;
        // llamando al api: Configurations/UpdateProponentUser
        setCargandoSpin(true);
        usersServicio.cargaSearchUserLDAP(props.tokenStore, bodyAPIBuscar)
          .then((response:any) => {
              if (response.status==200) {  //revisa si hay error
                  guardaSearchUserLDAPStore(response.data, bodyAPIBuscar).then( function(datos:any) { 
                      //console.log('actualizamos API: ', datos );
                      setUsuariosLDAPFront(datos);
                      setSwActivaListaLDAP(true);
                  });     
              }    
              setCargandoSpin(false);
              setSwRecarga(!swRecarga);
          })
          .catch((ex) => {
              console.log ("--catch - ex (cargaInsertbyUser): ", ex.response.status);
              generaObjErrorUsersStore(ex.response, true, '', '', 'Configuracion.Panel.Editar/cargaSearchUserLDAP','C');
              recargaPaginaSSC();
              setCargandoSpin(false);
          })
      }

      const agregaUsuarioLDAP =  (datosUsu:any) => {
        var espejo:any = document.getElementById("inputLDAP") as HTMLInputElement | null; 
        espejo.value= datosUsu.name;  
        setSwActivaListaLDAP(false);
        setUsuariosSeleccionado(datosUsu);
        setSwBotonAgregarFront(true)
        setSwBotonBuscarFront(false);
        //console.log('usuariosSeleccionado............', usuariosSeleccionado)
        setSwRecarga(!swRecarga);
      }

      const botonAgregar =  () => {
        //alert('botonAgregar')
        //console.log('LDPA ----usuariosSeleccionado....', usuariosSeleccionado);
        let regUsu = { "name": usuariosSeleccionado.name, "account": usuariosSeleccionado.email}
        let arrPaso:any = [];
        let swExiste = false;
        arrPaso = listaUsuariosFront;
        if (arrPaso.length>0){
            arrPaso.map((p:any, indexP:any) => {
              //console.log('p.account....',p.account,' regUsu....', regUsu.account);
              if (p.account == regUsu.account) { swExiste = true }
            });
            if (swExiste == false) { arrPaso.push(regUsu) };
        }
        else { arrPaso.push(regUsu) }
        setSwActivaListaLDAP(false);
        //setSwBotonGuardarFront(true);
        props.activaSwBotonGuardar();
        setSwBotonBuscarFront(false);
        setSwBotonAgregarFront(false);
        var espejo:any = document.getElementById("inputLDAP") as HTMLInputElement | null; 
        espejo.value= '';  
        setListaUsuariosFront(arrPaso); //actualizo aquí
       
        recargaConfiguracionPanelEditar();
        recargaConfiguracionPanel();
        setSwRecarga(!swRecarga);
        props.cambiaListaUsuarios(props.usuTipo, arrPaso); //actualizamos en EditarUN para que cuando guarde se lo lleve
      }
     
      const boteBasura =  (usuario:any) => {
         //alert('boteBasura: ' + usuario );
         setSwRecarga(!swRecarga);
         //console.log('boteBasura-....listaUsuariosFront', listaUsuariosFront);
         //console.log('boteBasura-....usuario', usuario);
         let arrPaso:any = [];
         let arrPaso2:any = [];
         arrPaso = listaUsuariosFront;
         console.log('boteBasura-....arrPaso', arrPaso);
         if (arrPaso.length>0){
             arrPaso.map((p:any, indexP:any) => {
               //console.log('p.account....',p.account,' regUsu....', regUsu.account);
               if (p.account != usuario) { arrPaso2.push(p) }
             });
         }
         //console.log('boteBasura-....arrPaso2', arrPaso2);
         else { setListaUsuariosFront(arrPaso2) }; //actualizo aquí
         props.cambiaListaUsuarios(props.usuTipo, arrPaso2); //actualizamos en EditarUN para que cuando guarde se lo lleve
         setListaUsuariosFront(arrPaso2);
         props.activaSwBotonGuardar();

         //console.log('boteBasura-....listaUsuariosFront', listaUsuariosFront);
         //setSwBotonGuardarFront(true);
         //console.log('upUsuariosEspecificosFront....', upUsuariosEspecificosFront);

         recargaConfiguracionPanelEditarLDAP();
         recargaConfiguracionPanelEditar();
         recargaConfiguracionPanel();
        
      }

    //**vista 
      return (
        <>
          {/* ventana LDAP */}
            <div className="UsuariosE ">
             
              {/* pasos */}
              <div className="row padding-left-1r ">
                <label  className="color-Gris5">Pasos para agregar un usuario específico: </label> <br />
                <div className="col-md-12 small  padding-left-1r  ">
                  <label className="colorBlue1">Paso 1:</label> <br />
                      <i className='mdi mdi-check color-azul5 font-size-12'></i> <span className='color-Gris2'>Ingrese la <b>clave de usuario</b> de correo electrónico Institucional <b>(clave.usuario)</b> por ejemplo (juan.perez)</span><br />
                      <i className='mdi mdi-check color-azul5 font-size-12'></i> <span className='color-Gris2'>Ingrese los <b>apellidos</b> seguidos por el <b>nombre(s)</b>; por ejemplo (PEREZ LOPEZ JUAN o PEREZ LOPEZ)</span>
                  <br />
                  <label><span className="colorBlue1">Paso 2:</span>&nbsp;
                    <span className="color-Gris2">Presione <span className="colorBlue1"><b>'Buscar'</b></span>, (abre lista de usuarios)</span>
                  </label> <br />
                  <label><span  className="colorBlue1">Paso 3:</span>&nbsp;
                    <span className="color-Gris2">Seleccione el usuario de la lista</span>
                  </label> <br />
                  <label><span  className="colorBlue1">Paso 4:</span>&nbsp;
                    <span  className="color-Gris2">Presione <span className="colorBlue1 font-weight-bold"><b>'Agregar'</b></span></span>
                  </label> <br />
                  <label><span className="colorBlue1">Paso 5:</span>&nbsp;
                    <span className="color-Gris2">Verifique si el usuario seleccionado se encuentre en la lista <span className="colorBlue1 font-weight-bold">'Usuarios específicos seleccionados'</span></span>
                  </label> <br />
                  <label><span className="colorBlue1">Recuerde</span>&nbsp;
                    <span className="color-Gris2">para registrar los cambios presione <span className="colorBlue1 font-weight-bold"><b>'Guardar'</b></span></span>
                  </label> <br />
                </div>
              </div>

              <br />

              {/* input & botón Buscar & botón Aceptar */}
              <div className="row padding-left-1r ">
                <label  className="color-Gris5">Seleccione el usuario a agregar </label> <br />
                <div className="row padding-left-1r">
                  <div className="col-sm-6">
                    <input id='inputLDAP' type="text" onChange={actualizaInputLDAP} placeholder="Clave de usuario / Apellidos / Nombre(s)" className="form-control form-control-dark background-color-white" /> 
                  </div>
                  <div className="col-sm-1"><a type="button"  className="inputLdapX cursorHand zIndex-1" onClick={limpiarInputLDAP}>x</a></div>                              
                  <div className="col-sm-2">
                    { swBotonBuscarFront  
                        ? (<> <button onClick={botonBuscar} className="btn btn-activo min-width-130"> Buscar </button>&nbsp; </>)
                        : (<> <button className="btn btn-inactivo min-width-130" disabled> Buscar </button>&nbsp; </>)
                    }
                  </div>  
                  <div className="col-md-2">
                    { swBotonAgregarFront  
                        ? (<> <button onClick={botonAgregar} className="btn btn-activoAzulMarino min-width-130"> Agregar </button> </>)
                        : (<> <button className="btn btn-activoAzulMarino min-width-130" disabled> Agregar </button> </>)
                    }
                  </div>                            
                </div>
              </div>

              {/* ventana con lista de LDAP*/}
              { swActivaListaLDAP &&
                (<>
                  <div className="padding-left-1r"> 
                    <label className="color-Gris5">Seleccione el usuario a agregar </label> <br />
                    <div className="container background-color-azul2 usuarioLdap">
                      { usuariosLDAPFront?.map((usu:any, indexUsu:any) => (
                        (<>
                            <a href="#" onClick={()=>agregaUsuarioLDAP(usu)} className='color-Gris1 font-size-10 text-decoration-none'>
                              <i className="mdi mdi-account-check-outline colorBlue1"></i>&nbsp;{usu.name}
                            </a><br/>
                        </>)  
                      ))}
                    </div>
                  </div> 
                  <br/>
                </>)
              }

              {/* Usuarios específicos seleccionados (1)  noBR small margin-1r*/}
              <div className="padding-left-1r"> 
                <label className="color-Gris5">Usuarios específicos seleccionados ( {listaUsuariosFront.length} )</label><br />
                <div className="container background-color-white usuarioLdap"> 
                    { listaUsuariosFront?.map((usu:any, indexUsu:any) => (
                      (<>
                        <div className="row color-Gris1 font-size-10 "> 
                            <div className="col-md-4 ">
                                <i className="mdi mdi-account-check-outline color-azul2">&nbsp;</i>{usu.name}
                            </div>&nbsp;
                            <div className="col-md-4 ">
                                <i className="mdi mdi-email-check-outline color-azul2">&nbsp;</i>{usu.account}
                            </div>
                            <div className="col-md-2">
                                <button onClick={()=>boteBasura(usu.account)} className="btn"> <i className="mdi mdi-trash-can-outline color-red"></i> </button>
                                {/* <button  type="button" className="btn rounded-pill " ng-click="page.setDeleteUserEsp(setPro,usuSel.account,'a_u');">
                                  <i className="mdi mdi-trash-can-outline color-red"></i></button>&nbsp; */}
                            </div>
                        </div>  
                      </>)  
                    ))} 
                </div>    
              </div>              

            </div>
           
          {/* ventana de carga con spin que se abre mientras lee el api */}
           { cargandoSpin && <CargandoSpin />  }          
          
      </>
      );
  }
